import React, { Component } from 'react'
import View from './view'
import withAuthorization from '../with-authorization'

export default class extends Component {
  render() {
		const authCondition = (authUser) => {
			return !!authUser && authUser.emailVerified
		}

		const RenderView = withAuthorization(authCondition)(View, this.props)
		
    return (
			<RenderView {...this.props} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/components/route-with-auth/index.js